// @ts-nocheck

import * as Types from '../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetCsvTemplatesQueryVariables = Types.Exact<{
  type: Types.CsvTemplateTypeModel;
  subType?: Types.InputMaybe<Types.CsvTemplateSubTypeModel>;
}>;

export type GetCsvTemplatesQuery = {
  csvTemplates: {
    items?: Array<{
      uid: string;
      default?: boolean | null;
      template?: { uid: string; filename?: string | null } | null;
    } | null> | null;
  };
};

export const GetCsvTemplatesDocument = gql`
    query GetCsvTemplates($type: CsvTemplateTypeModel!, $subType: CsvTemplateSubTypeModel) {
  csvTemplates(query: {type: $type, subType: $subType}) {
    items {
      uid
      default
      template {
        uid
        filename
      }
    }
  }
}
    ` as unknown as DocumentNode<GetCsvTemplatesQuery, GetCsvTemplatesQueryVariables>;
